import { Routes } from "@angular/router";
const routes: Routes = [
  {
    path: 'demora', children: [
      {
        path: 'index/:UsuarioId/:ClienteId', loadChildren: () => import('./demora-index.module')
          .then(t => t.DemoraIndexModule)
      }
    ]
  },

]
export function getRoutesCronometros() {
  return routes;
}
//aqui estan las rutas de proyecto, en este caso solo hay una que es la principal, y se pide en el URL
//el UsuarioId y el ClienteId, ahora mismo de CFO se esta mandando en duro ese Cliente
